import React, { FC } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { maxBy } from 'lodash'
import orderBy from 'lodash/orderBy'

import { currencyFormatter } from '../../utils'

import { BarLine } from './BarLine'
import { HorizontalBarProps } from './types'

export const HorizontalMultiBar: FC<HorizontalBarProps> = ({
  data,
  mainColor,
  minZonePresents,
  maxZonePresents,
  currency,
  percentType = false,
}) => {
  const { palette, spacing } = useTheme()

  const sortedData = orderBy(data, 'value', ['desc'])

  const max = maxBy(sortedData, ({ value }) => Number(value))?.value || 1

  return (
    <Box height="100%" minWidth={0} display="flex" gap={spacing(2)}>
      <Box display="flex" flexDirection="column" gap={spacing(2)} minWidth={0} maxWidth="32%">
        {sortedData.map(({ parameter }) => (
          <Typography
            key={parameter}
            fontSize={13}
            fontWeight="bold"
            height={spacing(2.4)}
            noWrap
            title={parameter}
          >
            {parameter}
          </Typography>
        ))}
      </Box>

      <Box flex={1} minWidth={0} display="flex" flexDirection="column" gap={spacing(2)}>
        {sortedData.map(({ parameter, value }) => {
          const percentage = (value / max) * 100
          let bgColor = mainColor || (palette.yellow[400] as string)
          if (minZonePresents && value <= minZonePresents) {
            bgColor = palette.green[400] as string
          } else if (maxZonePresents && value >= maxZonePresents) {
            bgColor = palette.red[400] as string
          }

          return <BarLine key={parameter} bgColor={bgColor} percentage={percentage} />
        })}
      </Box>

      <Box display="flex" flexDirection="column" gap={spacing(2)} flexShrink={0}>
        {sortedData.map(({ parameter, value }) => {
          const roundedValue = Math.ceil(value)
          return (
            <Typography
              key={parameter}
              fontSize={13}
              fontWeight="bold"
              height={spacing(2.4)}
              textAlign="end"
            >
              {`${currency ? currencyFormatter(currency, roundedValue, {}, true) : roundedValue}${
                percentType ? '%' : ''
              }`}
            </Typography>
          )
        })}
      </Box>
    </Box>
  )
}
